import { Button, Heading, Text, VStack } from 'native-base'
import { useEffect } from 'react'
import { useAuthContext } from '../../providers/AuthProvider'

const MagicLinkLogin = ({ email }) => {
  const { linkForLogin } = useAuthContext()
  const sendMagicLink = () => linkForLogin(email)

  useEffect(sendMagicLink, [])

  return (
    <VStack h="100%" w="100%" style={{ gap: 12 }}>
      <Heading fontSize={'2xl'} mt="3" color="primary.900">
        Welcome back!
      </Heading>
      <Text color="primary.900" fontSize={'md'}>
        Click the link in your email to continue.
      </Text>
      <Text color="primary.900" fontSize={'md'}>
        Be sure to check your spam folder if you can’t find the email.
      </Text>
      <Button
        testID="continue-log-in-button"
        onPress={sendMagicLink}
        variant="link">
        <Text color="secondary.600" underline>
          Resend email
        </Text>
      </Button>
    </VStack>
  )
}

export default MagicLinkLogin
